import type { FaireProductEntity } from "../../entity_types/product";

export const p_f5ehkkvnh3: FaireProductEntity = {
  token: "p_f5ehkkvnh3",
  type: "product",
  name: "Super Spa Set | Floral Multi, Self-Care, Easter, Mother's Da",
  brandToken: "b_197fd05f",
  brandName: "Pinch Provisions",
  imageUrl:
    "https://cdn.faire.com/fastly/8547ee439e1fdbc2e09fb9a3114738c517be5edf61dcc67ba278ec8dd0ece64b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4e911e595af7a152a13716d4fbcfc304d0958d67c857d625dbb7dbf25366e18f.jpeg",
    "https://cdn.faire.com/fastly/ed6a3e29208ff3180357fdd9769b29e32f5feaf7f2adcd7fdae18c230510efb7.jpeg",
    "https://cdn.faire.com/fastly/cab7a157eadb844e03d110d38a690ffc6cffd0858883e3727964bc5d8963e92e.png",
  ],
  priceDollars: 27.39,
  description:
    "The Super Spa Set by Pinch Provisions is the ultimate self-care gift. Thoughtfully packed in a nostalgic ivory jelly tote with a coordinating drawstring bag and scarf twill, this deluxe set is ready to gift and enjoy. Each set includes 8 premium spa essentials for the ultimate at-home pampering session: full-size ice roller, silky sleep mask, gua sha, exfoliating mitt, acetate hair clip, lavender shower steamer, scalp massager, and silky scrunchie. Also available in Orchid, Sea Glass, Periwinkle, Leopard, and Coral.\n",
  tags: [],
  msrpDollars: 54.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:43.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
